import WebsiteServiceModel            from '@/models/WebsiteServiceModel';
import doc                            from '@widesk-core/decorators/doc';

export default class FileModel extends WebsiteServiceModel {
	private declare _tsFilters: {
		'partial': string;
		'createdBy': id;
		'typeSource': id;
		'typeSource.type': id;
		'typeSource.type.service': id;
		'typeSource.type.service.serviceUrn': Urn;
		'typeSource.type.reference': Website_StonecodeFileTypeReference;
		'typeSource.source': id;
		'typeSource.source.entityUrn': Urn;
		'fileTypeVisibilities': id;
		'fileTypeVisibilities.typeVisibility': id;
		'fileTypeVisibilities.typeVisibility.visibility': id;
		'fileTypeVisibilities.typeVisibility.visibility.reference': Website_StonecodeFileVisibilityReference;
		'fileStatus': id;
		'fileStatus.reference': Website_StonecodeFileFileStatusReference;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
	};

	private declare _tsSorts: {
		id: string;
		createdAt: string;
		updatedAt: string;
	};

	static get path(): string {
		return 'stonecode_file_files/{?id}';
	}

	@doc.string declare label: string;
	@doc.string declare name: string;
	@doc.string declare description: string;
	@doc.number declare size: number;
	@doc.date declare date: Dayjs;
	@doc.boolean declare public: boolean;
}
